export enum OutcomeResults {
    WIN = "WIN",
    LOSE = "LOSE",
    VOID = "VOID",
    CASHOUT = "CASHED_OUT",
}
